<template>
  <h3>{{ $t("user.remindTitle") }}</h3>

  <form class="form" @submit.prevent="onSubmit()">
    <FormGroup :v="v$.email" label="label.email">
      <TextField
        v-model="formValue.email"
        type="text"
        inputmode="email"
        name="email"
        :disabled="props.saving"
        placeholder="placeholder.email"
        autocomplete="email"
      />
    </FormGroup>
    <div class="form__actions">
      <AppButton type="submit" :loading="props.saving">
        {{ $t("user.remind") }}
      </AppButton>
    </div>
    <slot />
  </form>
</template>

<script setup lang="ts">
import AppButton from "@/components/app-button.vue";
import FormGroup from "@/components/form/form-group.vue";
import TextField from "@/components/form/text-field.vue";
import { computed, reactive } from "vue";
import { email, required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import { UserRemindData } from "@/types";

const props = defineProps<{
  saving?: boolean;
  errors?: Record<string, string[]>;
}>();

const emit = defineEmits<{
  (e: "submit", v: UserRemindData): void;
}>();

const formValue = reactive<UserRemindData>({
  email: "",
});

const rules = computed(() => ({
  email: { required, email },
}));

const v$ = useVuelidate(rules, formValue, {
  $externalResults: computed(() => props.errors) as any,
});

const onSubmit = () => {
  v$.value.$touch();

  if (!v$.value.$invalid) {
    emit("submit", { ...formValue });
  }
};
</script>
